export const bytesToB64 = (bytes) => {
  let bin = "";
  for (let i = 0; i < bytes.length; i += 32768) bin += String.fromCharCode.apply(null, bytes.subarray(i, i + 32768));
  return btoa(bin);
};

export const b64ToBytes = (b64) => {
  const bin = atob(b64);
  const out = new Uint8Array(bin.length);
  for (let i = 0; i < bin.length; i += 1) out[i] = bin.charCodeAt(i);
  return out;
};

export const saveBlob = (blob, name) => {
  const a = document.createElement("a");
  a.href = URL.createObjectURL(blob);
  a.download = name;
  a.click();
  setTimeout(() => URL.revokeObjectURL(a.href), 5000);
};

export const UPLOAD_CHUNK = 256 * 1024;
export const UPLOAD_MAX = 100 * 1024 * 1024;

// Sends a file to the remote PC in chunks (it lands in the user's Downloads folder, or rel inside it).
export const sendFile = async (send, file, rel, onProgress, onReq) => {
  const bytes = new Uint8Array(await file.arrayBuffer());
  const total = Math.max(1, Math.ceil(bytes.length / UPLOAD_CHUNK));
  const req = `put-${Date.now()}-${Math.random().toString(36).slice(2, 7)}`;
  onReq?.(req);
  for (let i = 0; i < total; i += 1) {
    send({ type: "fs_put", req, name: file.name, rel: rel || undefined, seq: i, last: i === total - 1, data: bytesToB64(bytes.subarray(i * UPLOAD_CHUNK, (i + 1) * UPLOAD_CHUNK)) });
    onProgress?.(Math.round(((i + 1) * 100) / total));
    await new Promise((r) => setTimeout(r, 20));
  }
  return req;
};
